export default {
    modalShowImageVariations: {
        imageAi: 'Immagine IA',
        regenerateImage: 'Generare nuovo contenuto',
        description: 'Descrizione',
        style: 'Stile',
        saveToLibrary: 'Salva nella Libreria',
        continue: 'Continua',
        cancel: 'Annulla',
        select: 'Seleziona',
        copy: 'Copia',
        selectedImage: 'Immagine selezionata',
        saved: 'Salvato',
        variations: 'Variazioni',
    },
};
